'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import MenuButton from '../../../../MenuButton/viewer/skinComps/SeparateLinesMenuButtonNSkin/SeparateLinesMenuButtonNSkin';
import styles from './SeparateLinesMenuButtonSkin.scss';
import SeparateLinesMenuButton from './SeparateLinesMenuButton';

const SeparateLinesMenuButtonSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <SeparateLinesMenuButton
      {...props}
      ref={ref}
      styles={styles}
      Button={MenuButton}
    />
  );
};

export default React.forwardRef(SeparateLinesMenuButtonSkin);
